import React, { useEffect, useState, useRef } from "react";
import ImageMapper from "react-img-mapper";
import {
  Grid,
  Button,
  Box,
  Typography,
  styled,
  Stack,
  Paper,
  Divider,
  Modal,
} from "@mui/material";
//Images
import reefscapeField from "../images/reefscapeField.png";
import walle from "../images/walle.png";

const Mapper = ({
  parentWidth,
  image,
  map,
  onSelectArea,
  updateRobotPosition,
}) => {
  const [url, setURL] = React.useState("");
  const [robotCoords, setRobotCoords] = useState({ x: 0, y: 0 });
  const [parentWidths, setParentWidths] = useState(0);
  const [open, setOpen] = useState(false);
  const robotSize = parentWidth / 10;
  const isImageLoadedRef = useRef(false);

  useEffect(() => {
    setURL(image === "reefscape" ? reefscapeField : reefscapeField);
    setParentWidths(parentWidth);
  }, [parentWidth]);

  const handleClick = (area, event) => {
    if (!isImageLoadedRef.current) {
      return;
    }

    // Find the image inside the ImageMapper
    const img = document.querySelector("img[usemap='#my-map']");

    const rect = img.getBoundingClientRect();

    const x = Math.floor(
      event?.nativeEvent?.clientX - rect?.left - robotSize / 2
    );
    const y = Math.floor(
      event?.nativeEvent?.clientY - rect?.top - robotSize / 2
    );

    setRobotCoords({ x, y });

    if (area.name === "robotPosition") {
      let width = x - rect.left;
      let percent = ((width / parentWidth) * 100).toFixed(0);
      updateRobotPosition(percent);
    }

    onSelectArea(area?.name);
  };

  const handleLoad = () => {
    requestAnimationFrame(() => {
      isImageLoadedRef.current = true;
    });
  };

  return (
    <Box sx={{ position: "relative" }}>
      <ImageMapper
        src={url}
        name="my-map"
        areas={map}
        onClick={(area, index, event) => handleClick(area, event)}
        parentWidth={parentWidths}
        responsive={true}
        onLoad={() => handleLoad()}
      />
      {robotCoords?.x !== 0 && (
        <img
          src={walle}
          height={robotSize}
          width={robotSize}
          style={{
            left: robotCoords?.x,
            top: robotCoords?.y,
            position: "absolute",
          }}
        />
      )}
    </Box>
  );
};

export default Mapper;
